import { render } from "./Feedback.vue?vue&type=template&id=cc949b84&scoped=true"
import script from "./Feedback.vue?vue&type=script&lang=js"
export * from "./Feedback.vue?vue&type=script&lang=js"

import "./Feedback.vue?vue&type=style&index=0&id=cc949b84&scoped=true&lang=less"

import exportComponent from "E:\\case\\要点传达商城\\6-5\\eshop-vant4-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc949b84"]])

export default __exports__